(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Selector_1 = __webpack_require__(2);
var ComponentConfiguration_1 = __webpack_require__(14);
var ValueAndParent = (function () {
    function ValueAndParent(_value, _parant) {
        this.value = _value;
        this.parent = _parant;
    }
    return ValueAndParent;
}());
var UkuleleUtil = (function () {
    function UkuleleUtil() {
    }
    UkuleleUtil.searchHtmlTag = function (htmlString, tagName) {
        var reTemp = "^<" + tagName + "[\\s\\S]*>" + "[\\s\\S]*</" + tagName + ">$";
        var re = new RegExp(reTemp);
        var index = htmlString.search(re);
        return index;
    };
    UkuleleUtil.getInnerHtml = function (htmlString, tagName) {
        var reTemp = "<" + tagName + "[\\s\\S]*>" + "[\\s\\S]*</" + tagName + ">";
        var re = new RegExp(reTemp);
        var match = htmlString.match(re);
        if (match.index > -1) {
            var matchString = match[0];
            var index = matchString.search(">");
            var tempString = matchString.substr(index + 1);
            var index2 = tempString.lastIndexOf("</");
            tempString = tempString.substring(0, index2);
            tempString = tempString.replace(/(^\s*)|(\s*$)/g, "");
            return tempString;
        }
        else {
            return null;
        }
    };
    UkuleleUtil.getComponentConfiguration = function (htmlString) {
        var tempDom = document.createElement("div");
        tempDom.innerHTML = htmlString;
        var tpl = Selector_1.Selector.querySelectorAll(tempDom, "template");
        var scripts = Selector_1.Selector.querySelectorAll(tempDom, "script");
        var stylesheet = Selector_1.Selector.querySelectorAll(tempDom, "style");
        var deps = [];
        var ccs = null;
        for (var i = 0; i < scripts.length; i++) {
            var script = scripts[i];
            if (script.src !== "") {
                deps.push(script.src);
            }
            else {
                ccs = script.innerHTML;
            }
        }
        if (stylesheet && stylesheet[0]) {
            return new ComponentConfiguration_1.ComponentConfiguration(tpl[0].innerHTML, deps, ccs, stylesheet[0].innerHTML);
        }
        else {
            return new ComponentConfiguration_1.ComponentConfiguration(tpl[0].innerHTML, deps, ccs);
        }
    };
    UkuleleUtil.searchUkuAttrTag = function (htmlString) {
        var re = /^uku\-.*/;
        var index = htmlString.search(re);
        return index;
    };
    UkuleleUtil.isUkuAttrTag = function (tagName) {
        if (this.searchUkuAttrTag(tagName) > -1) {
            return true;
        }
        return false;
    };
    UkuleleUtil.getAttrFromUkuTag = function (ukuTag, camelCase) {
        if (camelCase === void 0) { camelCase = false; }
        if (UkuleleUtil.searchUkuAttrTag(ukuTag) === 0) {
            ukuTag = ukuTag.replace('uku-', '');
        }
        if (camelCase) {
            var names = ukuTag.split('-');
            ukuTag = names[0];
            for (var i = 1; i < names.length; i++) {
                var firstLetter = names[i].charAt(0).toUpperCase();
                ukuTag = ukuTag + firstLetter + names[i].substr(1);
            }
        }
        return ukuTag;
    };
    UkuleleUtil.searchUkuExpTag = function (expression) {
        var re = /^\{\{.*\}\}$/;
        var index = expression.search(re);
        return index;
    };
    UkuleleUtil.searchUkuFuncArg = function (htmlString) {
        var re1 = /[\+\-\*\/\%\?\:\>\<]/;
        var index = htmlString.search(re1);
        if (index === -1) {
            var re2 = /\(.*\)$/;
            index = htmlString.search(re2);
            return index;
        }
        else {
            return -1;
        }
    };
    UkuleleUtil.isRepeat = function (element) {
        if (element.getAttribute("uku-repeat")) {
            return true;
        }
        return false;
    };
    UkuleleUtil.isInRepeat = function (element) {
        var parents = Selector_1.Selector.parents(element);
        for (var i = 0; i < parents.length; i++) {
            var parent_1 = parents[i];
            if (parent_1.nodeType !== 9) {
                var b = parent_1.getAttribute("uku-repeat");
                if (b) {
                    return true;
                }
            }
        }
        return false;
    };
    UkuleleUtil.getBoundModelInstantName = function (expression) {
        var controlInstName = expression.split('.')[0];
        if (controlInstName) {
            return controlInstName;
        }
        return undefined;
    };
    UkuleleUtil.getBoundModelInstantNames = function (controller_alias_list, expression) {
        var arr = [];
        controller_alias_list.forEach(function (alias) {
            var pattern = new RegExp("\\b" + alias, "gm");
            console.count('getBoundModelInstantNames执行的次数');
            if (expression.search(pattern) > -1) {
                arr.push(alias);
            }
        });
        return arr;
    };
    UkuleleUtil.getFinalValue = function (objects, attrName) {
        return (function () {
            var tempScope = {};
            objects.forEach(function (object) {
                tempScope[object['_alias']] = object;
                var alias = object['_alias'];
                var pattern = new RegExp("\\b" + alias + "\\b", "gm");
                attrName = attrName.replace(pattern, "tempScope." + alias);
                var pattern2 = new RegExp("\\.tempScope\\." + alias, "gm");
                attrName = attrName.replace(pattern2, "." + alias);
            });
            var result;
            try {
                result = eval(attrName);
            }
            catch (err) {
                result = '';
            }
            tempScope = null;
            return result;
        })();
    };
    UkuleleUtil.setFinalValue = function (object, attrName, value) {
        return (function () {
            var tempScope = {};
            tempScope[object['_alias']] = object;
            var valueString;
            if (typeof value === "string") {
                valueString = '"' + value + '"';
            }
            else if (typeof value === "object") {
                valueString = "JSON.parse('" + JSON.stringify(value) + "')";
            }
            else {
                valueString = value;
            }
            var evalString = "tempScope." + attrName + "=" + valueString;
            eval(evalString);
        })();
    };
    UkuleleUtil.wrapScriptInComponent = function (originalScript) {
        var trimScript = originalScript.replace(new RegExp('\\s', 'gm'), '');
        if (trimScript.search(new RegExp('\\(function\\(')) === 0) {
            return originalScript;
        }
        else {
            var selfExcutingFrame = "\t(function(){\n                        return function(uku){                \n                            Object.defineProperty(this, 'currentState', {\n                                set: function(value){\n                                    if(value){\n                                        this._currentState = value;\n                                        uku.refresh(this._alias);\n                                    }\n                                }\n                            });\n\n                            this.setState = function(state){\n                                this._currentState = state;\n                                uku.refresh(this._alias);\n                            };\n\n                            " + originalScript + "\n                        };\n                    })();\n                ";
            return selfExcutingFrame;
        }
    };
    return UkuleleUtil;
}());
exports.UkuleleUtil = UkuleleUtil;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemBase_1 = __webpack_require__(3);
var UkuleleUtil_1 = __webpack_require__(0);
//import {SelectedDecorator} from "./decorator/SelectedDecorator";
var BoundItemAttribute = (function (_super) {
    __extends(BoundItemAttribute, _super);
    function BoundItemAttribute(attrName, ukuTag, element, uku) {
        var _this = _super.call(this, attrName, element, uku) || this;
        _this.ukuTag = ukuTag;
        return _this;
    }
    BoundItemAttribute.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        if (typeof finalValue === 'boolean') {
            if (finalValue === true) {
                this.element.setAttribute(this.ukuTag, this.ukuTag);
            }
            else {
                this.element.removeAttribute(this.ukuTag);
            }
        }
        else {
            this.element.setAttribute(this.ukuTag, finalValue);
        }
    };
    return BoundItemAttribute;
}(BoundItemBase_1.BoundItemBase));
exports.BoundItemAttribute = BoundItemAttribute;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Selector = (function () {
    function Selector() {
    }
    Selector.querySelectorAll = function (element, query) {
        if (window.hasOwnProperty('jQuery') && typeof window['jQuery'] !== "undefined") {
            return window['jQuery'](element).find(query);
        }
        else {
            return element.querySelectorAll(query);
        }
    };
    Selector.fuzzyFind = function (element, text) {
        if (element && element.attributes) {
            for (var i = 0; i < element.attributes.length; i++) {
                var attr = element.attributes[i];
                if (attr.nodeName.search(text) > -1) {
                    return element;
                }
            }
        }
        return null;
    };
    Selector.directText = function (element, text) {
        var o = "";
        var nodes = element.childNodes;
        for (var i = 0; i <= nodes.length - 1; i++) {
            var node = nodes[i];
            if (node.nodeType === 3) {
                if (text || text === "" || text === 0 || text === false) {
                    node.nodeValue = text;
                    return;
                }
                else {
                    o += node.nodeValue;
                }
            }
        }
        return o.trim();
    };
    Selector.parents = function (element) {
        var parents = [];
        while (element.parentNode && element.parentNode.tagName !== 'BODY') {
            parents.push(element.parentNode);
            element = element.parentNode;
        }
        return parents;
    };
    return Selector;
}());
exports.Selector = Selector;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemBase = (function () {
    function BoundItemBase(_attrName, _element, _uku) {
        this.attributeName = _attrName;
        this.element = _element;
        this.uku = _uku;
    }
    BoundItemBase.prototype.render = function (controllers) {
    };
    return BoundItemBase;
}());
exports.BoundItemBase = BoundItemBase;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Event = (function () {
    function Event(_eventType, _element) {
        this.eventType = _eventType;
        this.element = _element;
    }
    return Event;
}());
exports.Event = Event;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = (function () {
    function EventEmitter() {
        this.eventsPool = {};
    }
    EventEmitter.prototype.getEventsPool = function () {
        return this.eventsPool;
    };
    EventEmitter.prototype.addListener = function (eventType, handler) {
        if (!this.eventsPool[eventType]) {
            this.eventsPool[eventType] = [];
        }
        this.eventsPool[eventType].push(handler);
    };
    EventEmitter.prototype.removeListener = function (eventType, handler) {
        if (this.eventsPool[eventType]) {
            for (var i = this.eventsPool[eventType].length - 1; i >= 0; i--) {
                if (this.eventsPool[eventType][i] === handler) {
                    this.eventsPool[eventType].splice(i, 1);
                    break;
                }
            }
        }
    };
    EventEmitter.prototype.hasListener = function (eventType) {
        if (this.eventsPool[eventType] && this.eventsPool[eventType].length > 0) {
            return true;
        }
        return false;
    };
    EventEmitter.prototype.dispatchEvent = function (event) {
        if (event && event.eventType) {
            var handlers = this.eventsPool[event.eventType];
            if (handlers) {
                for (var i = 0; i < handlers.length; i++) {
                    handlers[i].call(this, event);
                }
            }
        }
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UkuEventType = (function () {
    function UkuEventType() {
    }
    UkuEventType.INITIALIZED = 'initialized';
    UkuEventType.REFRESH = 'refresh';
    UkuEventType.HANDLE_ELEMENT_COMPLETED = "handle_element_completed";
    return UkuEventType;
}());
exports.UkuEventType = UkuEventType;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EventListener = (function () {
    function EventListener() {
    }
    EventListener.addEventListener = function (element, eventType, handler) {
        return element.addEventListener(eventType, handler);
    };
    return EventListener;
}());
exports.EventListener = EventListener;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = __webpack_require__(5);
var DefinitionManager_1 = __webpack_require__(9);
var DirtyChecker_1 = __webpack_require__(15);
var Analyzer_1 = __webpack_require__(17);
var Selector_1 = __webpack_require__(2);
var UkuEventType_1 = __webpack_require__(6);
var Event_1 = __webpack_require__(4);
exports.Ukulele = (_a = (function (_super) {
        __extends(Ukulele, _super);
        function Ukulele() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.promiseArray = [];
            _this._childrenUku = {};
            return _this;
        }
        Ukulele.prototype.init = function () {
            var _this = this;
            Promise.all(this.promiseArray).then(function () {
                _this.manageApplication();
            });
        };
        Ukulele.prototype.setChildrenUku = function (controllers, uku) {
            for (var _i = 0, controllers_1 = controllers; _i < controllers_1.length; _i++) {
                var cc = controllers_1[_i];
                var alias = cc._alias;
                if (!this._childrenUku[alias]) {
                    this._childrenUku[alias] = [];
                }
                this._childrenUku[alias].push(uku);
            }
        };
        Ukulele.prototype.handleElement = function (element, handleElementCompletedFunc) {
            var _this = this;
            this.analyizeElement(element, function (e) {
                _this.dispatchEvent(new Event_1.Event(UkuEventType_1.UkuEventType.HANDLE_ELEMENT_COMPLETED, e));
                if (handleElementCompletedFunc && typeof handleElementCompletedFunc === 'function') {
                    handleElementCompletedFunc(e.element);
                }
            });
        };
        Ukulele.prototype.registerController = function (instanceName, controllerInst) {
            window[instanceName] = controllerInst;
            this._internal_getDefinitionManager().addControllerDefinition(instanceName, controllerInst);
        };
        Ukulele.prototype.getController = function (instanceName) {
            return this._internal_getDefinitionManager().getControllerDefinition(instanceName).controllerInstance;
        };
        Ukulele.prototype.registerComponent = function (tag, templateUrl, preload) {
            var p = this._internal_getDefinitionManager().addComponentDefinition(tag, templateUrl, preload);
            this.promiseArray.push(p);
        };
        Ukulele.prototype.getComponent = function (tagName) {
            return this._internal_getDefinitionManager().getComponent(tagName);
        };
        Ukulele.prototype.getComponentController = function (componentId) {
            return this._internal_getDefinitionManager().getControllerInstByDomId(componentId);
        };
        Ukulele.prototype.refresh = function (alias, excludeElement) {
            if (!this.dirtyChecker) {
                this.dirtyChecker = new DirtyChecker_1.DirtyChecker(this);
            }
            this.dirtyChecker.runDirtyChecking(alias, excludeElement);
        };
        //internal function
        Ukulele.prototype._internal_getDefinitionManager = function () {
            if (!this.defMgr) {
                this.defMgr = new DefinitionManager_1.DefinitionManager(this);
            }
            return this.defMgr;
        };
        Ukulele.prototype._internal_dealWithElement = function (element, callback) {
            this.analyizeElement(element, callback);
        };
        Ukulele.prototype.manageApplication = function () {
            var _this = this;
            var apps = Selector_1.Selector.querySelectorAll(document, "[uku-application]");
            if (apps.length === 1) {
                this.analyizeElement(apps[0], function (ele) {
                    _this.dispatchEvent(new Event_1.Event(UkuEventType_1.UkuEventType.INITIALIZED, ele));
                });
            }
            else {
                throw new Error("Only one 'uku-application' can be declared in a whole html.");
            }
        };
        Ukulele.prototype.analyizeElement = function (element, callback) {
            var anylyzer = new Analyzer_1.Analyzer(this);
            if (callback) {
                (function (retFunc) {
                    anylyzer.addListener(Analyzer_1.Analyzer.ANALYIZE_COMPLETED, function (e) {
                        retFunc(e.element);
                    });
                })(callback);
            }
            anylyzer.analyizeElement(element);
        };
        return Ukulele;
    }(EventEmitter_1.EventEmitter)),
    _a.INITIALIZED = 'initialized',
    _a.REFRESH = 'refresh',
    _a.HANDLE_ELEMENT_COMPLETED = "handle_element_completed",
    _a);
var _a;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Ajax_1 = __webpack_require__(10);
var ControllerModel_1 = __webpack_require__(11);
var ComponentModel_1 = __webpack_require__(12);
var ComponentPoolItem_1 = __webpack_require__(13);
var UkuleleUtil_1 = __webpack_require__(0);
var DefinitionManager = (function () {
    function DefinitionManager(_uku) {
        this.controllersDefinition = {};
        this.componentsDefinition = {};
        this.componentsPool = {};
        this.copyControllers = {};
        this.dependentScriptsCache = {};
        this.ajax = new Ajax_1.Ajax();
        this.uku = _uku;
    }
    DefinitionManager.prototype.getComponentsDefinition = function () {
        return this.componentsDefinition;
    };
    DefinitionManager.prototype.getComponentsPool = function () {
        return this.componentsPool;
    };
    DefinitionManager.prototype.setComponentsPool = function (pool) {
        this.componentsPool = pool;
    };
    DefinitionManager.prototype.setComponentsDefinition = function (value) {
        this.componentsDefinition = value;
    };
    DefinitionManager.prototype.getComponentDefinition = function (tagName) {
        return this.componentsDefinition[tagName];
    };
    DefinitionManager.prototype.getControllerDefinition = function (instanceName) {
        return this.controllersDefinition[instanceName];
    };
    DefinitionManager.prototype.getControllersDefinition = function () {
        return this.controllersDefinition;
    };
    DefinitionManager.prototype.getComponent = function (tagName) {
        return this.componentsPool[tagName];
    };
    DefinitionManager.prototype.getCopyControllers = function () {
        return this.copyControllers;
    };
    DefinitionManager.prototype.addControllerDefinition = function (instanceName, controllerInst) {
        var controllerModel = new ControllerModel_1.ControllerModel(instanceName, controllerInst);
        controllerInst._alias = instanceName;
        this.controllersDefinition[instanceName] = controllerModel;
    };
    DefinitionManager.prototype.getControllerInstByDomId = function (domId) {
        for (var alias in this.controllersDefinition) {
            var controllerModel = this.controllersDefinition[alias];
            var controller = controllerModel.controllerInstance;
            if (controller._dom && controller._dom.id === domId) {
                return controller;
            }
        }
        return undefined;
    };
    DefinitionManager.prototype.addComponentDefinition = function (tag, templateUrl, preload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!preload) {
                _this.componentsPool[tag] = new ComponentPoolItem_1.ComponentPoolItem(tag, templateUrl, true);
                resolve();
            }
            else {
                _this.componentsPool[tag] = new ComponentPoolItem_1.ComponentPoolItem(tag, templateUrl, false);
                return _this.ajax.get(templateUrl).then(function (result) {
                    var componentConfig = UkuleleUtil_1.UkuleleUtil.getComponentConfiguration(result);
                    return _this.analyizeComponent(tag, componentConfig);
                });
            }
        });
    };
    DefinitionManager.prototype.addLazyComponentDefinition = function (tag, templateUrl) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.ajax.get(templateUrl).then(function (result) {
                var componentConfig = UkuleleUtil_1.UkuleleUtil.getComponentConfiguration(result);
                return _this.analyizeComponent(tag, componentConfig).then(function () {
                    _this.componentsPool[tag] = { 'tagName': tag, 'templateUrl': templateUrl, 'lazy': false };
                    resolve();
                });
            });
        });
    };
    DefinitionManager.prototype.getBoundAttributeValue = function (attr) {
        var additionalArgu = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additionalArgu[_i - 1] = arguments[_i];
        }
        var controllerModels = this.getControllerModelByName(attr);
        var controllers = [];
        controllerModels.forEach(function (controllerModel) {
            controllers.push(controllerModel.controllerInstance);
        });
        var parameters = [this.uku, controllers, attr];
        parameters = parameters.concat(additionalArgu);
        var result = UkuleleUtil_1.UkuleleUtil.getFinalValue.apply(null, parameters);
        return result;
    };
    ;
    DefinitionManager.prototype.getControllerModelByName = function (expression) {
        var _this = this;
        var arr = [];
        var normalReg = /\$\w+\./g;
        var normals = expression.match(normalReg);
        if (normals) {
            normals.forEach(function (matchAlias) {
                matchAlias = matchAlias.substr(0, matchAlias.length - 1);
                var controllerModel = _this.controllersDefinition[matchAlias];
                arr.push(controllerModel);
            });
        }
        var ccReg = /cc\_\w*\./g;
        var ccs = expression.match(ccReg);
        if (ccs) {
            ccs.forEach(function (ccAlias) {
                ccAlias = ccAlias.substr(0, ccAlias.length - 1);
                var controllerModel = _this.controllersDefinition[ccAlias];
                arr.push(controllerModel);
            });
        }
        var repeatReg = /repeatItem\_\w*\$/g;
        var repeats = expression.match(repeatReg);
        if (repeats) {
            repeats.forEach(function (repeatAlias) {
                //repeatAlias = repeatAlias.substr(0,repeatAlias.length-1);
                var controllerModel = _this.controllersDefinition[repeatAlias];
                arr.push(controllerModel);
            });
        }
        return arr;
    };
    ;
    DefinitionManager.prototype.getFinalValueByExpression = function (expression) {
        var controllerModels = this.getControllerModelByName(expression);
        var controllers = [];
        controllerModels.forEach(function (controllerModel) {
            controllers.push(controllerModel.controllerInstance);
        });
        return UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, expression);
    };
    ;
    DefinitionManager.prototype.analyizeComponent = function (tag, config) {
        return __awaiter(this, void 0, void 0, function () {
            function loadDependentScript(src) {
                return new Promise(function (resolve, reject) {
                    if (!self.dependentScriptsCache[src]) {
                        var head = document.getElementsByTagName('HEAD')[0];
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.charset = 'utf-8';
                        script.async = true;
                        script.src = src;
                        script.onload = function (e) {
                            self.dependentScriptsCache[e.target['src']] = true;
                            resolve();
                        };
                        head.appendChild(script);
                    }
                    else {
                        resolve();
                    }
                });
            }
            var deps, self, tmpAMD, ccsExternal, _a, i, dep;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        deps = config.dependentScripts;
                        self = this;
                        if (!(deps && deps.length > 0)) return [3 /*break*/, 7];
                        tmpAMD = void 0;
                        if (typeof window['define'] === 'function' && window['define'].amd) {
                            tmpAMD = window['define'];
                            window['define'] = undefined;
                        }
                        if (!!config.componentControllerScript) return [3 /*break*/, 2];
                        ccsExternal = deps[deps.length - 1];
                        _a = config;
                        return [4 /*yield*/, this.ajax.get(ccsExternal)];
                    case 1:
                        _a.componentControllerScript = _b.sent();
                        deps.pop();
                        _b.label = 2;
                    case 2:
                        i = 0;
                        _b.label = 3;
                    case 3:
                        if (!(i < deps.length)) return [3 /*break*/, 6];
                        dep = deps[i];
                        return [4 /*yield*/, loadDependentScript(dep)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 3];
                    case 6:
                        if (tmpAMD) {
                            window['define'] = tmpAMD;
                        }
                        this.buildeComponentModel(tag, config.template, config.componentControllerScript, config.stylesheet);
                        return [2 /*return*/];
                    case 7:
                        this.buildeComponentModel(tag, config.template, config.componentControllerScript, config.stylesheet);
                        return [2 /*return*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    DefinitionManager.prototype.buildeComponentModel = function (tag, template, script, style) {
        var debugComment = "//# sourceURL=" + tag + ".js";
        try {
            var controllerClazz = void 0;
            if (script) {
                script = UkuleleUtil_1.UkuleleUtil.wrapScriptInComponent(script);
                script += debugComment;
                controllerClazz = eval(script);
            }
            var newComp = new ComponentModel_1.ComponentModel(tag, template, controllerClazz);
            this.componentsDefinition[tag] = newComp;
            if (style) {
                dealWithShadowStyle(tag, style);
            }
        }
        catch (e) {
            console.error(e);
        }
        function dealWithShadowStyle(tagName, stylesheet) {
            var head = document.getElementsByTagName('HEAD')[0];
            var style = document.createElement('style');
            style.type = 'text/css';
            var styleArray = stylesheet.split("}");
            var newArray = [];
            styleArray.forEach(function (value, index) {
                var newValue = value.replace(/^\s*/, "");
                if (newValue) {
                    newArray.push(newValue);
                }
            });
            stylesheet = newArray.join("}\n" + "." + tagName + " ");
            stylesheet = "." + tagName + " " + stylesheet + "}";
            style.innerHTML = stylesheet;
            head.appendChild(style);
        }
    };
    return DefinitionManager;
}());
exports.DefinitionManager = DefinitionManager;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Ajax = (function () {
    function Ajax() {
    }
    Ajax.prototype.get = function (url) {
        return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    if (request.status === 200) {
                        resolve(request.responseText);
                    }
                    else {
                        reject();
                    }
                }
            };
            request.open("GET", url, true);
            request.send(null);
        });
    };
    return Ajax;
}());
exports.Ajax = Ajax;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ControllerModel = (function () {
    function ControllerModel(alias, ctrlInst) {
        this.alias = alias;
        this.controllerInstance = ctrlInst;
        this.boundItems = [];
    }
    ControllerModel.prototype.addBoundItem = function (boundItem) {
        this.boundItems.push(boundItem);
    };
    ControllerModel.prototype.getBoundItemsByName = function (name) {
        var tempBoundItems = [];
        for (var i = 0; i < this.boundItems.length; i++) {
            var boundItem = this.boundItems[i];
            if (boundItem.attributeName === name) {
                tempBoundItems.push(boundItem);
            }
        }
        return tempBoundItems;
    };
    return ControllerModel;
}());
exports.ControllerModel = ControllerModel;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentModel = (function () {
    function ComponentModel(tagName, template, clazz) {
        this.tagName = tagName;
        this.template = template;
        this.controllerClazz = clazz;
    }
    return ComponentModel;
}());
exports.ComponentModel = ComponentModel;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentPoolItem = (function () {
    function ComponentPoolItem(_tagName, _templateUrl, _lazy) {
        this.tagName = _tagName;
        this.templateUrl = _templateUrl;
        this.lazy = _lazy;
    }
    return ComponentPoolItem;
}());
exports.ComponentPoolItem = ComponentPoolItem;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentConfiguration = (function () {
    function ComponentConfiguration(_template, _dependentScripts, _componentControllerScript, _stylesheet) {
        if (_stylesheet === void 0) { _stylesheet = undefined; }
        this.template = _template;
        this.dependentScripts = _dependentScripts;
        this.componentControllerScript = _componentControllerScript;
        this.stylesheet = _stylesheet;
    }
    return ComponentConfiguration;
}());
exports.ComponentConfiguration = ComponentConfiguration;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UkuleleUtil_1 = __webpack_require__(0);
var ObjectUtil_1 = __webpack_require__(16);
var UkuEventType_1 = __webpack_require__(6);
var Event_1 = __webpack_require__(4);
var DirtyChecker = (function () {
    function DirtyChecker(_uku) {
        this.oldValueCache = {};
        this.uku = _uku;
        this.defMgr = this.uku._internal_getDefinitionManager();
    }
    DirtyChecker.prototype.runDirtyChecking = function (ctrlAliasName, excludeElement) {
        var _this = this;
        if (ctrlAliasName) {
            if (typeof (ctrlAliasName) === "string") {
                watchController(ctrlAliasName);
            }
            else if (ObjectUtil_1.ObjectUtil.isArray(ctrlAliasName)) {
                for (var i = 0; i < ctrlAliasName.length; i++) {
                    watchController(ctrlAliasName[i]);
                }
            }
        }
        else {
            for (var alias in this.defMgr.getControllersDefinition()) {
                watchController(alias);
            }
        }
        function watchController(alias) {
            var controllerModel = _this.defMgr.getControllersDefinition()[alias];
            if (!controllerModel) {
                return;
            }
            var controller = controllerModel.controllerInstance;
            if (!_this.oldValueCache[alias]) {
                _this.oldValueCache[alias] = {};
            }
            var oldValueMap = _this.oldValueCache[alias];
            var changedElementCount = 0;
            for (var i = 0; i < controllerModel.boundItems.length; i++) {
                var boundItem = controllerModel.boundItems[i];
                var attrName = boundItem.attributeName;
                if (oldValueMap) {
                    if (boundItem.hasOwnProperty('ukuTag') && boundItem['ukuTag'] === "selected") {
                        attrName = attrName.split("|")[0];
                    }
                    var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue([controller], attrName);
                    var previousFinalValue = oldValueMap[attrName];
                    if (!ObjectUtil_1.ObjectUtil.compare(previousFinalValue, finalValue)) {
                        attrName = boundItem.attributeName;
                        var changedBoundItems = controllerModel.getBoundItemsByName(attrName);
                        for (var j = 0; j < changedBoundItems.length; j++) {
                            var changedBoundItem = changedBoundItems[j];
                            if (changedBoundItem.element !== excludeElement || (boundItem.hasOwnProperty('ukuTag') && changedBoundItem['ukuTag'] !== "value")) {
                                changedElementCount++;
                                changedBoundItem.render([controller]);
                            }
                        }
                        oldValueMap[attrName] = ObjectUtil_1.ObjectUtil.deepClone(finalValue);
                    }
                }
            }
            if (changedElementCount > 0 && _this.uku.hasListener(UkuEventType_1.UkuEventType.REFRESH)) {
                _this.uku.dispatchEvent(new Event_1.Event(UkuEventType_1.UkuEventType.REFRESH));
            }
        }
    };
    ;
    return DirtyChecker;
}());
exports.DirtyChecker = DirtyChecker;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ObjectUtil = (function () {
    function ObjectUtil() {
    }
    ObjectUtil.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    ObjectUtil.getType = function (obj) {
        var type = typeof (obj);
        if (type === "object") {
            if (ObjectUtil.isArray(obj)) {
                return "array";
            }
            else {
                return type;
            }
        }
        else {
            return type;
        }
    };
    ObjectUtil.deepClone = function (obj) {
        var o;
        var i;
        var j;
        if (typeof (obj) !== "object" || obj === null) {
            return obj;
        }
        if (obj instanceof (Array)) {
            o = [];
            i = 0;
            j = obj.length;
            for (; i < j; i++) {
                if (typeof (obj[i]) === "object" && obj[i] !== null) {
                    o[i] = ObjectUtil.deepClone(obj[i]);
                }
                else {
                    o[i] = obj[i];
                }
            }
        }
        else {
            o = {};
            for (i in obj) {
                if (typeof (obj[i]) === "object" && obj[i] !== null && i !== "_dom") {
                    o[i] = ObjectUtil.deepClone(obj[i]);
                }
                else {
                    o[i] = obj[i];
                }
            }
        }
        return o;
    };
    ObjectUtil.compare = function (objA, objB) {
        var type = ObjectUtil.getType(objA);
        var typeB = ObjectUtil.getType(objB);
        var result = true;
        if (type !== typeB) {
            return false;
        }
        else {
            switch (type) {
                case "object":
                    if (objA === null && objB === null) {
                        result = true;
                    }
                    else if (objA === null || objB === null) {
                        result = false;
                    }
                    else {
                        var keys_a = Object.keys(objA);
                        var keys_b = Object.keys(objB);
                        if (keys_a.length != keys_b.length) {
                            result = false;
                        }
                        else if (keys_a.length === 0 && keys_b.length === 0) {
                            result = true;
                        }
                        else {
                            for (var key in objA) {
                                var valuA = objA[key];
                                var valuB = objB[key];
                                var isEqual = ObjectUtil.compare(valuA, valuB);
                                if (!isEqual) {
                                    result = false;
                                    break;
                                }
                            }
                        }
                    }
                    break;
                case "array":
                    if (objA.length === objB.length) {
                        for (var i = 0; i < objA.length; i++) {
                            var itemA = objA[i];
                            var itemB = objB[i];
                            var isEqual2 = ObjectUtil.compare(itemA, itemB);
                            if (!isEqual2) {
                                result = false;
                                break;
                            }
                        }
                    }
                    else {
                        result = false;
                    }
                    break;
                case "function":
                    result = objA.toString() === objB.toString();
                    break;
                default:
                    result = objA === objB;
                    break;
            }
        }
        return result;
    };
    return ObjectUtil;
}());
exports.ObjectUtil = ObjectUtil;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = __webpack_require__(5);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttributeFactory_1 = __webpack_require__(18);
var BoundItemExpression_1 = __webpack_require__(27);
var BoundItemInnerText_1 = __webpack_require__(28);
var BoundItemRepeat_1 = __webpack_require__(29);
var BoundItemComponentAttribute_1 = __webpack_require__(30);
var ElementActionBinder_1 = __webpack_require__(31);
var EventListener_1 = __webpack_require__(7);
var Selector_1 = __webpack_require__(2);
var Event_1 = __webpack_require__(4);
var Analyzer = (function (_super) {
    __extends(Analyzer, _super);
    function Analyzer(_uku) {
        var _this = _super.call(this) || this;
        //处理绑定的attribute
        _this.dealWithAttribute = function (element, tagName) {
            var _this = this;
            var attr = element.getAttribute("uku-" + tagName);
            //let elementName = element.tagName;
            var controllerModels = this.defMgr.getControllerModelByName(attr);
            if (controllerModels && controllerModels.length > 0) {
                var boundItem_1 = BoundItemAttributeFactory_1.BoundItemAttributeFactory.getInstance().generateInstance(attr, tagName, element, this.uku);
                var controllers_1 = [];
                controllerModels.forEach(function (controllerModel) {
                    controllerModel.addBoundItem(boundItem_1);
                    ElementActionBinder_1.elementChangedBinder(element, tagName, controllerModel, _this.uku.refresh, _this.uku);
                    controllers_1.push(controllerModel.controllerInstance);
                });
                boundItem_1.render(controllers_1);
            }
        };
        _this.uku = _uku;
        _this.defMgr = _this.uku._internal_getDefinitionManager();
        return _this;
    }
    Analyzer.prototype.analyizeElement = function (ele) {
        var _this = this;
        this.searchComponent(ele).then(function (element) {
            _this.searchExpression(element);
            _this.searchUkuAttribute(element);
            //this.defMgr.copyAllController();
            if (_this.hasListener(Analyzer.ANALYIZE_COMPLETED)) {
                _this.dispatchEvent(new Event_1.Event(Analyzer.ANALYIZE_COMPLETED, element));
            }
        });
    };
    Analyzer.prototype.sortAttributes = function (subElement) {
        var orderAttrs = [];
        var listenerAttrs = [];
        for (var i = 0; i < subElement.attributes.length; i++) {
            var attribute = subElement.attributes[i];
            if (attribute.nodeName.search("uku-on") !== -1) {
                //orderAttrs.push(attribute);
                listenerAttrs.push(attribute);
            }
            else {
                orderAttrs.push(attribute);
            }
        }
        orderAttrs = orderAttrs.concat(listenerAttrs);
        return orderAttrs;
    };
    Analyzer.prototype.searchUkuAttribute = function (element) {
        var subElements = [];
        //scan element which has uku-* tag
        var isSelfHasUkuTag = Selector_1.Selector.fuzzyFind(element, 'uku-');
        if (isSelfHasUkuTag) {
            subElements.push(isSelfHasUkuTag);
        }
        var allChildren = Selector_1.Selector.querySelectorAll(element, "*");
        for (var i = 0; i < allChildren.length; i++) {
            var child = allChildren[i];
            var matchElement = Selector_1.Selector.fuzzyFind(child, 'uku-');
            if (matchElement && !UkuleleUtil_1.UkuleleUtil.isInRepeat(matchElement)) {
                subElements.push(matchElement);
            }
        }
        //解析绑定 attribute，注册event
        for (var n = 0; n < subElements.length; n++) {
            var subElement = subElements[n];
            var orderAttrs = this.sortAttributes(subElement);
            for (var j = 0; j < orderAttrs.length; j++) {
                var attribute = orderAttrs[j];
                if (UkuleleUtil_1.UkuleleUtil.searchUkuAttrTag(attribute.nodeName) > -1) {
                    var tempArr = attribute.nodeName.split('-');
                    tempArr.shift();
                    var attrName = tempArr.join('-');
                    if (attrName !== "application") {
                        if (attrName.search('on') === 0) {
                            //is an event
                            if (!UkuleleUtil_1.UkuleleUtil.isRepeat(subElement) && !UkuleleUtil_1.UkuleleUtil.isInRepeat(subElement)) {
                                this.dealWithEvent(subElement, attrName);
                            }
                        }
                        else if (attrName.search('repeat') !== -1) {
                            //is an repeat
                            this.dealWithRepeat(subElement);
                        }
                        else {
                            //is an attribute
                            if (!UkuleleUtil_1.UkuleleUtil.isRepeat(subElement) && !UkuleleUtil_1.UkuleleUtil.isInRepeat(subElement)) {
                                if (attrName !== "text") {
                                    this.dealWithAttribute(subElement, attrName);
                                }
                                else {
                                    this.dealWithInnerText(subElement);
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    Analyzer.prototype.searchComponent = function (element) {
        return __awaiter(this, void 0, void 0, function () {
            var comp, attrs, compDef, attrs, compDef, i, child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        comp = this.defMgr.getComponent(element.localName);
                        if (!comp) return [3 /*break*/, 4];
                        if (!!comp.lazy) return [3 /*break*/, 1];
                        attrs = element.attributes;
                        compDef = this.defMgr.getComponentsDefinition()[comp.tagName];
                        if (!UkuleleUtil_1.UkuleleUtil.isRepeat(element) && !UkuleleUtil_1.UkuleleUtil.isInRepeat(element)) {
                            return [2 /*return*/, this.dealWithComponent(element, compDef.template, compDef.controllerClazz, attrs)];
                        }
                        else {
                            return [2 /*return*/, element];
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.defMgr.addLazyComponentDefinition(comp.tagName, comp.templateUrl)];
                    case 2:
                        _a.sent();
                        attrs = element.attributes;
                        compDef = this.defMgr.getComponentsDefinition()[comp.tagName];
                        if (!UkuleleUtil_1.UkuleleUtil.isRepeat(element) && !UkuleleUtil_1.UkuleleUtil.isInRepeat(element)) {
                            return [2 /*return*/, this.dealWithComponent(element, compDef.template, compDef.controllerClazz, attrs)];
                        }
                        else {
                            return [2 /*return*/, element];
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 10];
                    case 4:
                        if (!(element.children && element.children.length > 0)) return [3 /*break*/, 9];
                        i = 0;
                        _a.label = 5;
                    case 5:
                        if (!(i < element.children.length)) return [3 /*break*/, 8];
                        child = element.children[i];
                        return [4 /*yield*/, this.searchComponent(child)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        i++;
                        return [3 /*break*/, 5];
                    case 8: return [2 /*return*/, element];
                    case 9: return [2 /*return*/, element];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Analyzer.prototype.dealWithComponent = function (tag, template, Clazz, attrs) {
        return __awaiter(this, void 0, void 0, function () {
            var time, randomAlias, tempFragment, htmlDom, cc, _loop_1, this_1, i, i, attr, j, child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        time = new Date().getTime();
                        randomAlias = 'cc_' + Math.floor(time * Math.random()).toString();
                        //should consider white space between characters
                        template = template.replace(new RegExp("\'cc\\.", 'gm'), "'" + randomAlias + '.');
                        template = template.replace(new RegExp('"cc\\.', 'gm'), '"' + randomAlias + '.');
                        template = template.replace(new RegExp('\{\{cc\\.', 'gm'), "{{" + randomAlias + '.');
                        template = template.replace(new RegExp(' cc\\.', 'gm'), ' ' + randomAlias + '.');
                        template = template.replace(new RegExp('\\(cc\\.', 'gm'), '(' + randomAlias + '.');
                        template = template.replace(new RegExp('\\,cc\\.', 'gm'), ',' + randomAlias + '.');
                        template = template.replace(new RegExp('\\.cc\\.', 'gm'), '.' + randomAlias + '.');
                        template = template.replace(new RegExp('\\!cc\\.', 'gm'), '!' + randomAlias + '.');
                        tempFragment = document.createElement('div');
                        tempFragment.insertAdjacentHTML('afterBegin', template);
                        if (tempFragment.children.length > 1) {
                            template = tempFragment.outerHTML;
                        }
                        tag.insertAdjacentHTML('beforeBegin', template);
                        htmlDom = tag.previousElementSibling;
                        htmlDom.classList.add(tag.localName);
                        if (Clazz) {
                            cc = new Clazz(this.uku);
                            cc._dom = htmlDom;
                            cc.fire = function (eventType, data, bubbles, cancelable) {
                                if (bubbles === void 0) { bubbles = false; }
                                if (cancelable === void 0) { cancelable = true; }
                                var event = new CustomEvent(eventType.toLowerCase(), { "bubbles": bubbles, "cancelable": cancelable });
                                event['data'] = data;
                                cc._dom.dispatchEvent(event);
                            };
                            this.uku.registerController(randomAlias, cc);
                            _loop_1 = function (i) {
                                var attr = attrs[i];
                                //todo need Refactor
                                if (UkuleleUtil_1.UkuleleUtil.searchUkuAttrTag(attr.nodeName) !== 0
                                    || attr.nodeName.search("uku-on") !== -1
                                    || attr.nodeName === "uku-render"
                                    || attr.nodeName === "uku-visible") {
                                    htmlDom.setAttribute(attr.nodeName, attr.nodeValue);
                                }
                                else {
                                    var tagName = UkuleleUtil_1.UkuleleUtil.getAttrFromUkuTag(attr.nodeName, true);
                                    var controllerModels = this_1.defMgr.getControllerModelByName(attr.nodeValue);
                                    if (controllerModels && controllerModels.length > 0) {
                                        var boundItem_2 = new BoundItemComponentAttribute_1.BoundItemComponentAttribute(attr.nodeValue, tagName, cc, this_1.uku);
                                        var controllers_2 = [];
                                        controllerModels.forEach(function (controllerModel) {
                                            controllerModel.addBoundItem(boundItem_2);
                                            controllers_2.push(controllerModel.controllerInstance);
                                        });
                                        boundItem_2.render(controllers_2);
                                    }
                                    else {
                                        //native value, not expression
                                        var boundItem = new BoundItemComponentAttribute_1.BoundItemComponentAttribute(attr.nodeValue, tagName, cc, this_1.uku);
                                        boundItem.render([]);
                                    }
                                }
                            };
                            this_1 = this;
                            for (i = 0; i < attrs.length; i++) {
                                _loop_1(i);
                            }
                        }
                        else {
                            for (i = 0; i < attrs.length; i++) {
                                attr = attrs[i];
                                //todo:need Refactor
                                if (UkuleleUtil_1.UkuleleUtil.searchUkuAttrTag(attr.nodeName) !== 0
                                    || attr.nodeName.search("uku-on") !== -1
                                    || attr.nodeName === "uku-render"
                                    || attr.nodeName === "uku-visible") {
                                    htmlDom.setAttribute(attr.nodeName, attr.nodeValue);
                                }
                            }
                        }
                        tag.parentNode.removeChild(tag);
                        if (!(htmlDom.children && htmlDom.children.length > 0)) return [3 /*break*/, 5];
                        j = 0;
                        _a.label = 1;
                    case 1:
                        if (!(j < htmlDom.children.length)) return [3 /*break*/, 4];
                        child = htmlDom.children[j];
                        return [4 /*yield*/, this.searchComponent(child)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        j++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (cc && cc._initialized && typeof (cc._initialized) === 'function') {
                            cc._initialized(randomAlias, cc._dom);
                        }
                        return [2 /*return*/, htmlDom];
                    case 5:
                        if (cc && cc._initialized && typeof (cc._initialized) === 'function') {
                            cc._initialized(randomAlias, cc._dom);
                        }
                        return [2 /*return*/, htmlDom];
                }
            });
        });
    };
    //todo: 处理 tag之间使用{{}}括起的表达式，用以显示文字
    Analyzer.prototype.searchExpression = function (element) {
        if (UkuleleUtil_1.UkuleleUtil.searchUkuExpTag(Selector_1.Selector.directText(element)) !== -1) {
            if (!UkuleleUtil_1.UkuleleUtil.isRepeat(element) && !UkuleleUtil_1.UkuleleUtil.isInRepeat(element)) {
                //normal expression
                this.dealWithExpression(element);
            }
        }
        for (var i = 0; i < element.children.length; i++) {
            this.searchExpression(element.children[i]);
        }
    };
    Analyzer.prototype.dealWithExpression = function (element) {
        //通常的花括号声明方式
        var expression = Selector_1.Selector.directText(element);
        if (UkuleleUtil_1.UkuleleUtil.searchUkuExpTag(expression) !== -1) {
            var attr = expression.slice(2, -2);
            var controllerModels = this.defMgr.getControllerModelByName(attr);
            if (controllerModels && controllerModels.length > 0) {
                var boundItem_3 = new BoundItemExpression_1.BoundItemExpression(attr, expression, element, this.uku);
                var controllers_3 = [];
                controllerModels.forEach(function (controllerModel) {
                    controllerModel.addBoundItem(boundItem_3);
                    controllers_3.push(controllerModel.controllerInstance);
                });
                boundItem_3.render(controllers_3);
            }
        }
    };
    //处理 uku-text
    Analyzer.prototype.dealWithInnerText = function (element) {
        var attr = element.getAttribute("uku-text");
        if (attr) {
            var controllerModels = this.defMgr.getControllerModelByName(attr);
            if (controllerModels && controllerModels.length > 0) {
                var boundItem_4 = new BoundItemInnerText_1.BoundItemInnerText(attr, element, this.uku);
                var controllers_4 = [];
                controllerModels.forEach(function (controllerModel) {
                    controllerModel.addBoundItem(boundItem_4);
                    controllers_4.push(controllerModel.controllerInstance);
                });
                boundItem_4.render(controllers_4);
            }
        }
    };
    //处理 事件 event
    Analyzer.prototype.dealWithEvent = function (element, eventName) {
        var _this = this;
        var expression = element.getAttribute("uku-" + eventName);
        var eventNameInListener = eventName.substring(2);
        eventNameInListener = eventNameInListener.toLowerCase();
        var controllerModels = this.defMgr.getControllerModelByName(expression);
        if (!controllerModels || controllerModels.length === 0) {
            controllerModels = [];
        }
        EventListener_1.EventListener.addEventListener(element, eventNameInListener, function (event) {
            var alias_list = [];
            controllerModels.forEach(function (controllerModel) {
                //this.defMgr.copyControllerInstance(controllerModel.controllerInstance, controllerModels.alias);
                alias_list.push(controllerModel.alias);
            });
            var index = UkuleleUtil_1.UkuleleUtil.searchUkuFuncArg(expression);
            if (index === -1) {
                // is an expression, not a function
                var handler = new Function("event", "return " + expression);
                console.log(handler.toString());
                handler(event);
            }
            else {
                // is a function
                var i = expression.search(/\(/);
                var arg = 'event';
                if (expression[i + 1] !== ')') {
                    // has argument
                    arg = 'event,';
                }
                var arr = expression.split('(');
                arr[1] = arg + arr[1];
                var new_expression_1 = arr.join("(");
                (function (e) {
                    var tempScope = {};
                    tempScope['event'] = e;
                    eval(new_expression_1);
                    tempScope = null;
                })(event);
            }
            _this.uku.refresh(alias_list, element);
        });
    };
    //处理 repeat
    Analyzer.prototype.dealWithRepeat = function (element) {
        var repeatExpression = element.getAttribute("uku-repeat");
        var tempArr = repeatExpression.split(' in ');
        var itemName = tempArr[0];
        var attr = tempArr[1];
        var controllerModels = this.defMgr.getControllerModelByName(attr);
        if (controllerModels && controllerModels.length > 0) {
            var controllers_5 = [];
            //let controllerInst = controllerModel.controllerInstance;
            var boundItem_5 = new BoundItemRepeat_1.BoundItemRepeat(attr, itemName, element, this.uku);
            controllerModels.forEach(function (controllerModel) {
                controllerModel.addBoundItem(boundItem_5);
                controllers_5.push(controllerModel.controllerInstance);
            });
            boundItem_5.render(controllers_5);
        }
    };
    Analyzer.ANALYIZE_COMPLETED = 'analyizeCompleted';
    return Analyzer;
}(EventEmitter_1.EventEmitter));
exports.Analyzer = Analyzer;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttrSelected_1 = __webpack_require__(19);
var BoundItemAttrDataItem_1 = __webpack_require__(20);
var BoundItemAttrSrc_1 = __webpack_require__(21);
var BoundItemAttrDisabled_1 = __webpack_require__(22);
var BoundItemAttrRender_1 = __webpack_require__(23);
var BoundItemAttrStyle_1 = __webpack_require__(24);
var BoundItemAttrValue_1 = __webpack_require__(25);
var BoundItemAttrVisible_1 = __webpack_require__(26);
var BoundItemAttribute_1 = __webpack_require__(1);
var BoundItemAttributeFactory = (function () {
    function BoundItemAttributeFactory() {
        if (BoundItemAttributeFactory._instance) {
            throw new Error("Error: Instantiation failed: Use BoundItemAttributeFactory.getInstance() instead of new.");
        }
        BoundItemAttributeFactory._instance = this;
    }
    BoundItemAttributeFactory.getInstance = function () {
        return BoundItemAttributeFactory._instance;
    };
    BoundItemAttributeFactory.prototype.generateInstance = function (attr, tagName, element, uku) {
        var instance;
        switch (tagName) {
            case "selected":
                instance = new BoundItemAttrSelected_1.BountItemAttrSelected(attr, tagName, element, uku);
                break;
            case "data-item":
                instance = new BoundItemAttrDataItem_1.BoundItemAttrDataItem(attr, tagName, element, uku);
                break;
            case "src":
                instance = new BoundItemAttrSrc_1.BoundItemAttrSrc(attr, tagName, element, uku);
                break;
            case "disabled":
                instance = new BoundItemAttrDisabled_1.BoundItemAttrDisabled(attr, tagName, element, uku);
                break;
            case "render":
                instance = new BoundItemAttrRender_1.BoundItemAttrRender(attr, tagName, element, uku);
                break;
            case "style":
                instance = new BoundItemAttrStyle_1.BoundItemAttrStyle(attr, tagName, element, uku);
                break;
            case "value":
                instance = new BoundItemAttrValue_1.BoundItemAttrValue(attr, tagName, element, uku);
                break;
            case "visible":
                instance = new BoundItemAttrVisible_1.BoundItemAttrVisible(attr, tagName, element, uku);
                break;
            default:
                instance = new BoundItemAttribute_1.BoundItemAttribute(attr, tagName, element, uku);
        }
        return instance;
    };
    BoundItemAttributeFactory._instance = new BoundItemAttributeFactory();
    return BoundItemAttributeFactory;
}());
exports.BoundItemAttributeFactory = BoundItemAttributeFactory;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BountItemAttrSelected = (function (_super) {
    __extends(BountItemAttrSelected, _super);
    function BountItemAttrSelected(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "selected") {
            throw new TypeError("it doesn't use uku-selected");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BountItemAttrSelected.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var key;
        var elementName = this.element.tagName;
        if (elementName === "SELECT") {
            var tempArr = this.attributeName.split("|");
            attr = tempArr[0];
            key = tempArr[1];
            var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
            var value = void 0;
            if (key) {
                value = finalValue[key];
            }
            else {
                value = finalValue;
            }
            this.element.value = value;
        }
        if (elementName === "INPUT" && this.element.getAttribute("type") === "radio") {
            var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
            if (this.element.value === finalValue) {
                this.element.setAttribute("checked", "true");
            }
        }
    };
    return BountItemAttrSelected;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BountItemAttrSelected = BountItemAttrSelected;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrDataItem = (function (_super) {
    __extends(BoundItemAttrDataItem, _super);
    function BoundItemAttrDataItem(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "data-item") {
            throw new TypeError("it doesn't use uku-item");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrDataItem.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var elementName = this.element.tagName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        if (elementName === "OPTION") {
            finalValue = JSON.stringify(finalValue);
            this.element.setAttribute('data-item', finalValue);
        }
    };
    return BoundItemAttrDataItem;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrDataItem = BoundItemAttrDataItem;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrSrc = (function (_super) {
    __extends(BoundItemAttrSrc, _super);
    function BoundItemAttrSrc(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "src") {
            throw new TypeError("it doesn't use uku-src");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrSrc.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var elementName = this.element.tagName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        if (elementName === "IMG" || elementName === "VIDEO" || elementName === "AUDIO") {
            if (finalValue) {
                this.element.setAttribute(this.ukuTag, finalValue);
            }
        }
        else {
            throw new Error("uku-src doesn't work with current dom");
        }
    };
    return BoundItemAttrSrc;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrSrc = BoundItemAttrSrc;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrDisabled = (function (_super) {
    __extends(BoundItemAttrDisabled, _super);
    function BoundItemAttrDisabled(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "disabled") {
            throw new TypeError("it doesn't use uku-disabled");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrDisabled.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var elementName = this.element.tagName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        this.element.disabled = finalValue;
    };
    return BoundItemAttrDisabled;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrDisabled = BoundItemAttrDisabled;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrRender = (function (_super) {
    __extends(BoundItemAttrRender, _super);
    function BoundItemAttrRender(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "render") {
            throw new TypeError("it doesn't use uku-render");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrRender.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        if (finalValue) {
            var oldDisplaySetting = this.element.getAttribute("data-old-display");
            if (oldDisplaySetting !== null) {
                this.element.style.display = oldDisplaySetting;
            }
        }
        else {
            var oldDisplaySetting = this.element.getAttribute("data-old-display");
            if (oldDisplaySetting === null) {
                oldDisplaySetting = this.element.style.display;
                this.element.setAttribute("data-old-display", oldDisplaySetting);
            }
            this.element.style.display = "none";
        }
    };
    return BoundItemAttrRender;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrRender = BoundItemAttrRender;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrStyle = (function (_super) {
    __extends(BoundItemAttrStyle, _super);
    function BoundItemAttrStyle(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "style") {
            throw new TypeError("it doesn't use uku-style");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrStyle.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var elementName = this.element.tagName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        for (var cssName in finalValue) {
            this.element.style[cssName] = finalValue[cssName];
        }
    };
    return BoundItemAttrStyle;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrStyle = BoundItemAttrStyle;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrValue = (function (_super) {
    __extends(BoundItemAttrValue, _super);
    function BoundItemAttrValue(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "value") {
            throw new TypeError("it doesn't use uku-value");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrValue.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var elementName = this.element.tagName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        if (elementName === "INPUT" && this.element.getAttribute("type") === "checkbox") {
            this.element.checked = finalValue;
        }
        else {
            this.element.value = finalValue;
        }
    };
    return BoundItemAttrValue;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrValue = BoundItemAttrValue;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemAttribute_1 = __webpack_require__(1);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemAttrVisible = (function (_super) {
    __extends(BoundItemAttrVisible, _super);
    function BoundItemAttrVisible(attrName, ukuTag, element, uku) {
        var _this = this;
        if (ukuTag !== "visible") {
            throw new TypeError("it doesn't use uku-visible");
        }
        _this = _super.call(this, attrName, ukuTag, element, uku) || this;
        return _this;
    }
    BoundItemAttrVisible.prototype.render = function (controllers) {
        var attr = this.attributeName;
        var elementName = this.element.tagName;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, attr);
        if (finalValue) {
            this.element.style.visibility = "visible";
        }
        else {
            this.element.style.visibility = "hidden";
        }
    };
    return BoundItemAttrVisible;
}(BoundItemAttribute_1.BoundItemAttribute));
exports.BoundItemAttrVisible = BoundItemAttrVisible;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemBase_1 = __webpack_require__(3);
var UkuleleUtil_1 = __webpack_require__(0);
var Selector_1 = __webpack_require__(2);
var BoundItemExpression = (function (_super) {
    __extends(BoundItemExpression, _super);
    function BoundItemExpression(attrName, expression, element, uku) {
        var _this = _super.call(this, attrName, element, uku) || this;
        _this.expression = expression;
        return _this;
    }
    BoundItemExpression.prototype.render = function (controllers) {
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, this.attributeName);
        Selector_1.Selector.directText(this.element, finalValue);
    };
    return BoundItemExpression;
}(BoundItemBase_1.BoundItemBase));
exports.BoundItemExpression = BoundItemExpression;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemBase_1 = __webpack_require__(3);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemInnerText = (function (_super) {
    __extends(BoundItemInnerText, _super);
    function BoundItemInnerText(attrName, element, uku) {
        var _this = _super.call(this, attrName, element, uku) || this;
        _this.tagName = 'text';
        return _this;
    }
    BoundItemInnerText.prototype.render = function (controllers) {
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, this.attributeName);
        this.element.innerHTML = finalValue;
    };
    return BoundItemInnerText;
}(BoundItemBase_1.BoundItemBase));
exports.BoundItemInnerText = BoundItemInnerText;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemBase_1 = __webpack_require__(3);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemRepeat = (function (_super) {
    __extends(BoundItemRepeat, _super);
    function BoundItemRepeat(attrName, itemName, element, uku) {
        var _this = _super.call(this, attrName, element, uku) || this;
        _this.expression = itemName;
        _this.renderTemplate = element.outerHTML;
        _this.parentElement = element.parentNode;
        _this.beginCommentString = undefined;
        _this.endCommentString = undefined;
        return _this;
    }
    BoundItemRepeat.prototype.replaceVarible = function (element, varName, alias) {
        var pattern = new RegExp("\\b" + varName + "(?!\\w)", "gm");
        var attributes = element.attributes;
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            if (UkuleleUtil_1.UkuleleUtil.isUkuAttrTag(attr.nodeName)) {
                attr.nodeValue = attr.nodeValue.replace(pattern, alias);
            }
        }
        var childTag = element.innerHTML.match(new RegExp("\\<\\w*.*\\>", "gm"));
        var innerText = element.innerHTML.match(new RegExp("\\{{[\\w\\W]*\\}\\}", "gm"));
        if (childTag === null
            && innerText !== null
            && innerText.length === 1) {
            element.textContent = element.textContent.replace(pattern, alias);
        }
        if (element.children && element.children.length > 0) {
            for (var j = 0; j < element.children.length; j++) {
                var child = element.children[j];
                this.replaceVarible(child, varName, alias);
            }
        }
    };
    BoundItemRepeat.prototype.render = function (controllers) {
        var _this = this;
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, this.attributeName);
        if (!finalValue) {
            return;
        }
        if (typeof finalValue === "number" && Math.floor(finalValue) === finalValue) {
            //finalValue = 
            var newFinalValue = [];
            for (var num = 1; num <= finalValue; num++) {
                //let item = {value: num};
                newFinalValue.push(num);
            }
            finalValue = newFinalValue;
        }
        var self = this;
        if (this.element && this.element.parentNode) {
            //create repeate begin comment
            this.beginCommentString = "begin uku-repeat: " + this.expression + " in " + this.attributeName;
            var beginComment = document.createComment(this.beginCommentString);
            this.element.parentNode.insertBefore(beginComment, this.element);
            //create repeate end comment
            this.endCommentString = "end uku-repeat: " + this.expression + " in " + this.attributeName;
            var endComment = document.createComment(this.endCommentString);
            this.element.parentNode.insertBefore(endComment, this.element.nextSibling);
            //remove definition dom
            this.element.parentNode.removeChild(this.element);
        }
        var filter = { acceptNode: function (node) {
                if (node.nodeValue === self.beginCommentString) {
                    return NodeFilter.FILTER_ACCEPT;
                }
                return NodeFilter.FILTER_SKIP;
            } };
        var safeFilter = filter.acceptNode;
        safeFilter.acceptNode = filter.acceptNode;
        var treeWalker = document.createTreeWalker(this.parentElement, NodeFilter.SHOW_COMMENT, safeFilter, false);
        function generateTempContainer() {
            var index = UkuleleUtil_1.UkuleleUtil.searchHtmlTag(self.renderTemplate, "tr");
            var index2 = UkuleleUtil_1.UkuleleUtil.searchHtmlTag(self.renderTemplate, "th");
            if (index === -1 || index2 === -1) {
                return document.createElement("tbody");
            }
            else {
                return document.createElement("div");
            }
        }
        while (treeWalker.nextNode()) {
            var commentNode = treeWalker.currentNode;
            if (commentNode && commentNode.nodeValue === this.beginCommentString) {
                //remove overtime dom.
                while (commentNode.nextSibling && commentNode.nextSibling.nodeValue !== this.endCommentString) {
                    commentNode.parentNode.removeChild(commentNode.nextSibling);
                }
                //create new dom
                var tempDiv = generateTempContainer();
                var blankDiv = generateTempContainer();
                commentNode.parentNode.insertBefore(blankDiv, commentNode.nextSibling);
                for (var i = 0; i < finalValue.length; i++) {
                    tempDiv.insertAdjacentHTML('beforeEnd', this.renderTemplate);
                    if (i === finalValue.length - 1) {
                        var childrenHTML = tempDiv.innerHTML;
                        blankDiv.insertAdjacentHTML('beforeBegin', childrenHTML);
                        commentNode.parentNode.removeChild(blankDiv);
                        tempDiv = null;
                        blankDiv = null;
                    }
                }
                var child = commentNode.nextElementSibling;
                var time = new Date().getTime();
                for (var j = 0; j < finalValue.length; j++) {
                    child.removeAttribute("uku-repeat");
                    var compDef = this.uku._internal_getDefinitionManager().getComponentsDefinition();
                    var compPool = this.uku._internal_getDefinitionManager().getComponentsPool();
                    this.uku._internal_getDefinitionManager().setComponentsDefinition(compDef);
                    this.uku._internal_getDefinitionManager().setComponentsPool(compPool);
                    var sibling = child.nextSibling;
                    var itemType = typeof finalValue[j];
                    var alias = "repeatItem_" + Math.floor(time * Math.random()).toString() + "_" + this.expression + "$";
                    if (itemType === "object") {
                        this.uku.registerController(alias, finalValue[j]);
                    }
                    else {
                        this.uku.registerController(alias, { 'value': finalValue[j] });
                        alias = alias + ".value";
                    }
                    this.replaceVarible(child, this.expression, alias);
                    child.insertAdjacentHTML('afterend', child.outerHTML);
                    var newItemDom = child.nextSibling;
                    child.parentNode.removeChild(child);
                    child = newItemDom;
                    this.uku._internal_dealWithElement(child, function (element) {
                        if (_this.element.tagName === "OPTION") {
                            var expression = _this.parentElement.getAttribute("uku-selected");
                            var tempArr = expression.split("|");
                            expression = tempArr[0];
                            var key = tempArr[1];
                            var value = _this.uku._internal_getDefinitionManager().getFinalValueByExpression(expression);
                            if (key) {
                                _this.parentElement.value = value[key];
                            }
                            else {
                                _this.parentElement.value = value;
                            }
                        }
                    });
                    child = sibling;
                }
            }
        }
    };
    return BoundItemRepeat;
}(BoundItemBase_1.BoundItemBase));
exports.BoundItemRepeat = BoundItemRepeat;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BoundItemBase_1 = __webpack_require__(3);
var UkuleleUtil_1 = __webpack_require__(0);
var BoundItemComponentAttribute = (function (_super) {
    __extends(BoundItemComponentAttribute, _super);
    function BoundItemComponentAttribute(attrName, ukuTag, cc, uku) {
        var _this = _super.call(this, attrName, null, uku) || this;
        _this.ukuTag = ukuTag;
        _this.componentController = cc;
        return _this;
    }
    BoundItemComponentAttribute.prototype.render = function (controllers) {
        var finalValue = UkuleleUtil_1.UkuleleUtil.getFinalValue(controllers, this.attributeName);
        this.componentController[this.ukuTag] = finalValue;
        this.uku.refresh(this.componentController._alias);
    };
    return BoundItemComponentAttribute;
}(BoundItemBase_1.BoundItemBase));
exports.BoundItemComponentAttribute = BoundItemComponentAttribute;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UkuleleUtil_1 = __webpack_require__(0);
var EventListener_1 = __webpack_require__(7);
var Selector_1 = __webpack_require__(2);
function elementChangedBinder(element, tagName, controllerModel, handler, host) {
    var elementStrategies = [inputTextCase, textareaCase, selectCase, checkboxCase, radioCase];
    for (var i = 0; i < elementStrategies.length; i++) {
        var func = elementStrategies[i];
        var goon = func.apply(this, arguments);
        if (goon) {
            break;
        }
    }
}
exports.elementChangedBinder = elementChangedBinder;
function inputTextCase(element, tagName, controllerModel, handler, host) {
    var elementName = element.tagName;
    if (elementName === "INPUT" && isSupportInputType(element) && tagName === "value") {
        var eventType = 'change';
        var inputType = element.getAttribute('type');
        if (inputType === "text"
            || inputType === "text"
            || inputType === "password"
            || inputType === "tel"
            || inputType === "number"
            || inputType === "search") {
            eventType = 'input';
        }
        EventListener_1.EventListener.addEventListener(element, eventType, function (e) {
            var attr = element.getAttribute("uku-" + tagName);
            UkuleleUtil_1.UkuleleUtil.setFinalValue(controllerModel.controllerInstance, attr, element.value);
            if (handler) {
                handler.call(host, controllerModel.alias, element);
            }
        });
        return true;
    }
    return false;
}
function isSupportInputType(element) {
    var type = element.getAttribute("type");
    if (type !== "checkbox" && type !== "radio") {
        return true;
    }
    return false;
}
function textareaCase(element, tagName, controllerModel, handler, host) {
    var elementName = element.tagName;
    if (elementName === "TEXTAREA" && tagName === "value") {
        EventListener_1.EventListener.addEventListener(element, 'input', function (e) {
            var attr = element.getAttribute("uku-" + tagName);
            UkuleleUtil_1.UkuleleUtil.setFinalValue(controllerModel.controllerInstance, attr, element.value);
            if (handler) {
                handler.call(host, controllerModel.alias, element);
            }
        });
        return true;
    }
    return false;
}
function selectCase(element, tagName, controllerModel, handler, host) {
    var elementName = element.tagName;
    if ((elementName === "SELECT" && tagName === "selected")) {
        EventListener_1.EventListener.addEventListener(element, 'change', function (e) {
            var attr = element.getAttribute("uku-" + tagName);
            var key;
            var tmpArr = attr.split("|");
            attr = tmpArr[0];
            var options = Selector_1.Selector.querySelectorAll(element, "option");
            for (var j = 0; j < options.length; j++) {
                var option = options[j];
                if (option.selected) {
                    var selectedItem = JSON.parse(option.getAttribute("data-item"));
                    UkuleleUtil_1.UkuleleUtil.setFinalValue(controllerModel.controllerInstance, attr, selectedItem);
                }
            }
            if (handler) {
                handler.call(host, controllerModel.alias, element);
            }
        });
        return true;
    }
    return false;
}
function checkboxCase(element, tagName, controllerModel, handler, host) {
    var elementName = element.tagName;
    if (elementName === "INPUT" && tagName === "value" && element.getAttribute("type") === "checkbox") {
        EventListener_1.EventListener.addEventListener(element, 'change', function (e) {
            var attr = element.getAttribute("uku-" + tagName);
            UkuleleUtil_1.UkuleleUtil.setFinalValue(controllerModel.controllerInstance, attr, element.checked);
            if (handler) {
                handler.call(host, controllerModel.alias, element);
            }
        });
        return true;
    }
    return false;
}
function radioCase(element, tagName, controllerModel, handler, host) {
    var elementName = element.tagName;
    if (elementName === "INPUT" && tagName === "selected" && element.getAttribute("type") === "radio") {
        EventListener_1.EventListener.addEventListener(element, 'change', function (e) {
            var attr = element.getAttribute("uku-" + tagName);
            if (element.checked) {
                UkuleleUtil_1.UkuleleUtil.setFinalValue(controllerModel.controllerInstance, attr, element.value);
                if (handler) {
                    handler.call(host, controllerModel.alias, element);
                }
            }
        });
        return true;
    }
    return false;
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// uku.js